import { api } from "./client";

export interface DispenseParams {
  page?: number;
  pageSize?: number;
  dateFrom?: string;
  dateTo?: string;
  userIds?: string;
  ndc?: string;
  itemName?: string;
  rxNumber?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export function getDispenses(params?: DispenseParams) {
  return api.get("/dispenses", { params });
}

export function getDispense(id: string) {
  return api.get(`/dispenses/${id}`);
}

export function createDispense(data: Record<string, unknown>) {
  return api.post<{
    dispense?: { id: string };
    isDuplicate?: boolean;
    warning?: string;
  }>("/dispenses", data);
}

export function checkDuplicate(data: { rxNumber: string; ndc: string }) {
  return api.post("/dispenses/check-duplicate", data);
}

export function checkStock(data: { inventoryId: string; quantity: number }) {
  return api.post("/dispenses/check-stock", data);
}

export function updateDispense(id: string, data: Record<string, unknown>) {
  return api.patch(`/dispenses/${id}`, data);
}

export function deleteDispense(
  id: string,
  data?: { password?: string; approvalToken?: string }
) {
  return api.delete(`/dispenses/${id}`, { body: data });
}
